<template>
  <div id="contact">
    <div class="content_box">
      <div class="img_container contact_img"></div>
      <div class="contents_title fade_in"> 
        <p class="contents_font"> Contact us </p>
      </div>
      <div class="content_info">
          
          <div class="contact_container">
            <div id="map_wrap" class="contact_item">
              <KakaoMap/>
            </div>

            <div class="contact_item">
              <p class="main_font margin_item"> Contact us </p>

              <div class="label_container">
                <div id="map_img" class="label_item label_icon"></div>
                <label class="label_item"> 위치 </label>
              </div>
              
              <p class="info_font pline"> [본사] 제주특별자치도 제주시 첨단로 330, 세미양빌딩 A동 3층 SL-307호 </p>
              <p class="info_font margin_item"> [서울지점] 서울특별시 강서구 마곡중앙8로 14 </p>
              
              <p class="main_font"> How to Contact? </p>
              
              <div class="btn_container margin_item">
                <div v-b-modal.modal-email class="email_form_btn"> Email </div>
              </div>
            </div>
          </div>


          <b-modal id="modal-email" 
            title="Email" 
            hide-footer="true"
            size="xl">
              <Email/>
            </b-modal>
        
      </div>
    </div>
  </div>

</template>

<script>
import Email from '../components/Email';
import KakaoMap from '../components/KakaoMap';

export default {
  components : {
    Email,
    KakaoMap
  }
}
</script>

<style>
#contact {
  text-align: center;
}

#map_wrap {
  width: 450px;
  height: 450px;

}

.contact_img {
  background-image: url(../../public/img/contact.jpg);
  filter: brightness(45%); 
}

.contact_container {
  margin-top: 50px;
  margin-bottom: 100px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}

.contact_item {
  text-align: center;
}

#map_img {
  background-image: url(../../public/icon/map.png);
}

.email_form_btn {
  text-align: center;
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;

  padding-top: 2px;
  width: 130px;
  height: 30px;
  border-radius: 35px;
  border: 1px solid #868686;
  color: #868686;
}

.email_form_btn:hover {
  cursor: pointer;
  color: #FFFFFF;
  border: 1px solid #00C0D6;
  background-color: #00C0D6;
}


</style>
